import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEmpresa } from '../contexts/EmpresaContext';
import '../styles/SuperAdminCompanySelector.css';

const SelectorEmpresaNOBUTTON = () => {
  const { empresaActiva, empresasUsuario, cambiarEmpresa } = useEmpresa();
  const [isOpen, setIsOpen] = useState(false);
  const [themeColor, setThemeColor] = useState('#c4fffc');
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Debug log
  useEffect(() => {
    console.log('🔍 SelectorEmpresaNOBUTTON - Estado actual:', {
      empresaActiva,
      empresasUsuario,
      empresasUsuarioLength: empresasUsuario?.length
    });
  }, [empresaActiva, empresasUsuario]);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleEmpresaChange = (empresa) => {
    console.log('🔄 Usuario regular seleccionando empresa:', empresa);
    console.log('📋 Empresa actual antes del cambio:', empresaActiva);

    // Guardar directamente en localStorage ANTES de cualquier otra acción
    const empresaMapeada = {
      id: empresa.id,
      nombreFantasia: empresa.tradeName || empresa.nombreFantasia,
      razonSocial: empresa.tradeName || empresa.razonSocial,
      rut: empresa.taxId || empresa.rut,
      logo: empresa.logo,
      plan: empresa.plan,
      rolUsuario: empresa.role || empresa.rolUsuario,
      permisos: empresa.permissions || empresa.permisos,
      permissions: empresa.permissions || empresa.permisos,
      tradeName: empresa.tradeName || empresa.nombreFantasia,
      taxId: empresa.taxId || empresa.rut,
      role: empresa.role || empresa.rolUsuario
    };

    console.log('💾 Guardando empresa mapeada en localStorage:', empresaMapeada);
    localStorage.setItem('empresaActiva', JSON.stringify(empresaMapeada));

    // Verificar que se guardó correctamente
    const verificacion = localStorage.getItem('empresaActiva');
    console.log('✅ Verificación - Empresa en localStorage después de guardar:', JSON.parse(verificacion));

    setIsOpen(false);

    // Recargar la página completamente
    console.log('🔄 Recargando página para aplicar cambios...');
    window.location.reload();
  };

  const getRolLabel = (rol) => {
    const roles = {
      admin: 'Administrador',
      editor: 'Editor',
      member: 'Miembro',
      vendedor: 'Vendedor',
      comprador: 'Comprador',
      finanzas: 'Finanzas',
      visor: 'Solo Lectura',
      viewer: 'Solo Lectura'
    };
    return roles[rol] || rol;
  };

  // Función para determinar si un color es claro u oscuro
  const isLightColor = (color) => {
    // Convertir hex a RGB
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calcular luminosidad
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5;
  };

  // Actualizar color del tema en tiempo real
  useEffect(() => {
    const updateThemeColor = () => {
      const color = localStorage.getItem('theme-primary-color') || '#c4fffc';
      setThemeColor(color);
    };

    // Actualizar inicialmente
    updateThemeColor();

    // Actualizar cada 200ms para capturar cambios inmediatos
    const interval = setInterval(updateThemeColor, 200);

    // Escuchar evento personalizado
    const handleThemeChange = () => {
      updateThemeColor();
    };
    window.addEventListener('theme-color-change', handleThemeChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('theme-color-change', handleThemeChange);
    };
  }, []);

  // Si no hay empresa activa ni empresas disponibles, mostrar estado de carga
  if (!empresaActiva && (!empresasUsuario || empresasUsuario.length === 0)) {
    return (
      <div style={{
        padding: '10px 14px',
        color: '#666',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        Cargando empresas...
      </div>
    );
  }

  // Si no hay empresa activa pero hay empresas, mostrar la primera
  if (!empresaActiva && empresasUsuario && empresasUsuario.length > 0) {
    console.warn('⚠️ No hay empresa activa pero hay empresas disponibles. Seleccionando la primera...');
    cambiarEmpresa(empresasUsuario[0]);
    return null;
  }

  const textColor = isLightColor(themeColor) ? '#000' : '#fff';

  // Debug: verificar qué hay en empresaActiva
  console.log('🏢 SelectorEmpresaNOBUTTON - empresaActiva:', empresaActiva);
  console.log('📛 nombreFantasia:', empresaActiva?.nombreFantasia);
  console.log('🏷️ tradeName:', empresaActiva?.tradeName);
  console.log('👔 rolUsuario:', empresaActiva?.rolUsuario);
  console.log('👤 role:', empresaActiva?.role);

  return (
    <div className="empresa-selector-wrapper" style={{ position: 'relative', display: 'inline-block' }} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: isOpen ? '#000' : themeColor,
          transition: 'background 0.2s ease, color 0.2s ease',
          border: '2px solid #000',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 14px',
          minWidth: '220px',
          cursor: 'pointer',
          fontFamily: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: '14px',
          fontWeight: '600',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          outline: 'none'
        }}
        ref={(el) => {
          if (el) {
            el.style.setProperty('color', isOpen ? themeColor : textColor, 'important');
          }
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = isOpen ? '#000' : themeColor;
          e.currentTarget.style.setProperty('color', isOpen ? themeColor : textColor, 'important');
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = isOpen ? '#000' : themeColor;
          e.currentTarget.style.setProperty('color', isOpen ? themeColor : textColor, 'important');
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
        <div style={{
          textAlign: 'left',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          minWidth: 0,
          maxWidth: window.innerWidth <= 768 ? 'none' : '180px'
        }}>
          <div style={{
            fontWeight: '700',
            fontSize: '14px',
            lineHeight: '1.2',
            whiteSpace: window.innerWidth <= 768 ? 'normal' : 'nowrap',
            overflow: 'hidden',
            textOverflow: window.innerWidth <= 768 ? 'clip' : 'ellipsis',
            color: 'inherit',
            visibility: 'visible',
            display: 'block'
          }}>
            {empresaActiva.nombreFantasia || empresaActiva.tradeName || 'Empresa'}
          </div>
          <div style={{
            fontSize: '11px',
            opacity: 0.75,
            lineHeight: '1.2',
            whiteSpace: 'nowrap',
            color: 'inherit',
            visibility: 'visible',
            display: 'block'
          }}>
            {getRolLabel(empresaActiva.rolUsuario || empresaActiva.role) || 'Rol'}
          </div>
        </div>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            flexShrink: 0,
            transition: 'transform 0.3s ease',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      {isOpen && (
        <div className="super-admin-dropdown">
          <div className="companies-list">
            {empresasUsuario.length === 0 ? (
              <div className="empty-state">
                <span>No hay empresas disponibles</span>
              </div>
            ) : (
              empresasUsuario.map((empresa) => {
                const isActive = empresaActiva && empresaActiva.id === empresa.id;
                return (
                  <div
                    key={empresa.id}
                    className={`company-option ${isActive ? 'active' : ''}`}
                    onClick={() => handleEmpresaChange(empresa)}
                    style={isActive ? {
                      background: themeColor,
                      color: isLightColor(themeColor) ? '#000' : '#fff'
                    } : {
                      background: '#fff',
                      color: '#000'
                    }}
                  >
                    <div className="company-icon" style={{
                      background: themeColor,
                      border: '2px solid #000'
                    }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={isLightColor(themeColor) ? '#000' : '#fff'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <path d="M3 9h18"></path>
                        <path d="M9 21V9"></path>
                      </svg>
                    </div>
                    <div className="company-details">
                      <div className="company-name" style={{ color: isActive ? (isLightColor(themeColor) ? '#000' : '#fff') : '#000' }}>
                        {empresa.nombreFantasia}
                      </div>
                      <div className="company-info">
                        <span className="company-tax-id" style={{ color: isActive ? (isLightColor(themeColor) ? '#000' : '#fff') : '#666' }}>
                          {empresa.rut || empresa.taxId}
                        </span>
                        <span className="company-users" style={{ color: isActive ? (isLightColor(themeColor) ? '#000' : '#fff') : '#666' }}>
                          {getRolLabel(empresa.rolUsuario)}
                        </span>
                      </div>
                    </div>
                    {isActive && (
                      <svg className="check-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={isLightColor(themeColor) ? '#000' : themeColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectorEmpresaNOBUTTON;